/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';
import { GRAPHQL_ENV } from '..';

/**
 * @param {string} brand - domain name: brand['domain-name']
 * @param {string} uid - uid: (the UID of the entry in cms)
 * @param {string} contentType - contentType: _content_type_uid (the content type ID)'
 * @param {Array<string>} [includeRefs=[]] - references to include
 */

const findContentByUID = ({
    brand, uid, contentType, includeRefs = [], queryName = 'findContentByUID',
}) => {
    const includeRef = includeRefs.length > 0 ? `"${includeRefs.join(',')}"` : '[]';
    return (
        gql`query ${queryName}{
            findContentByUID(brand: "${brand}", environment: "${GRAPHQL_ENV}",  locale: "en-us", contentType: "${contentType}", uid: "${uid}", includeRefs:${includeRef}){
            content
        }}`
    );
};

export default findContentByUID;
